import type { HtmlAssetDescription } from '../types';

/** The generated-graphic-specific fields of a serialized asset description. */
export type HtmlCompositionDescription = Pick<HtmlAssetDescription, 'parts' | 'texts' | 'status'>;

/**
 * Describe a composition document as what a video-level agent needs to reason about it: which
 * addressable parts exist and what editable copy it shows. The full HTML is deliberately never
 * serialized into video state — it's large, and authoring/editing it is the design subagent's job,
 * not the video-level agent's.
 */
export function describeHtmlComposition(html: string): HtmlCompositionDescription {
    if (!html) {
        return { status: 'empty (awaiting generation)' };
    }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const parts = Array.from(doc.querySelectorAll('[data-codeo-asset]'))
        .map((element) => element.getAttribute('data-codeo-asset') ?? '')
        .filter(Boolean);
    const editableTexts = Array.from(doc.querySelectorAll('[data-l5-editable="true"]'))
        .map((element) => (element.textContent ?? '').trim())
        .filter(Boolean);
    return {
        ...(parts.length ? { parts: parts.join(', ') } : {}),
        ...(editableTexts.length ? { texts: editableTexts.join(' | ') } : {}),
    };
}
